import type { ElementConfig } from '@/types';
import { Element } from './Element.class';

/**
 * 需要播放的功能的媒体类继承这个类
 */
export class MediaElement extends Element {
  constructor() {
    super();
  }

  public async applyConfig() {}

  public async updateConfig(config?: ElementConfig) {
    if (!this._data.config) this._data.config = {};

    if (!config) return;

    Object.assign(this._data.config, config);

    this.applyConfig();
  }

  public get mediaConfig() {
    return this._data.config;
  }

  public get mediaDuration() {
    return 0;
  }
}
